import { render, staticRenderFns } from "./ClientDetails.vue?vue&type=template&id=44a6b488&scoped=true&"
import script from "./ClientDetails.vue?vue&type=script&lang=ts&"
export * from "./ClientDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ClientDetails.vue?vue&type=style&index=0&id=44a6b488&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a6b488",
  null
  
)

export default component.exports